define('v3/Common/Components/Survey/Survey.Component',[
	'jquery',
	'knockout',
	'lodash',
	'env',
	'v3/Common/Components/Survey/Services/surveyService',
	'v3/Common/Models/enums',
	'v3/Common/Services/frontend/Frontend.Service',
	'v3/FromV2/cookieService',
	'text!v3/Common/Components/Survey/Survey.Component.html',
	'v3/Common/Bindings/SvgIcon.Binding',
	'v3/Common/Bindings/Mask.Binding',
	'v3/Common/Bindings/Tooltip.Binding'
], function ($, ko, _, env, surveyService, enums, frontend, cookieService, htmlString) {
	function SurveyViewModel (params) {
		var self = this;

		self.isClosable = params && params.isClosable;

		self.activeAnswer = ko.observable();
		self.surveyQuestions = ko.observableArray();
		self.activeQuestion = ko.observable();
		self.isLoading = ko.observable(false);
		self.isCompleted = ko.observable(!env.userInfo.hasSurvey());

		self.setActiveAnswer = function (item) {
			var activeQuestion = self.surveyQuestions()[self.activeQuestion()];

			_.each(activeQuestion.options, function (option) {
				if (option === item) {
					option.selected = true;
				} else {
					option.selected = false;
				}
			});

			if (activeQuestion.questionType === 6) {
				self.surveyQuestions.notifySubscribers();
			}

			self.activeAnswer(item);
		};

		self.activeQuestionTemplate = ko.computed(function () {
			if (self.surveyQuestions().length > 0 && !_.isNaN(self.activeQuestion())) {
				var data = self.surveyQuestions()[self.activeQuestion()];
				if (data) {
					if (data.questionType === 2) {
						self.setActiveAnswer(data, false);
					}
					return {
						data: data,
						template: self.getTemplate(data.questionType)
					};
				} else {
					return false;
				}
			} else {
				return false;
			}
		});

		self.goTo = function (newIndex, currentIndex, currentItem) {
			var previousQuestion = self.surveyQuestions()[currentIndex];
			var answerId = null;
			if (previousQuestion) {
				if (previousQuestion.options) {
					var answer = _.findIndex(previousQuestion.options, { 'selected': true });
					if (answer > -1) {
						answerId = previousQuestion.options[answer].answerId;
					}
				}

				if (previousQuestion.answerText || answerId) {
					surveyService.answerQuestion(previousQuestion.questionId, previousQuestion.answerText, answerId, false);
					previousQuestion.questionAnswered = true;
				}
			}

			self.activeQuestion(newIndex);
			self.setActiveAnswerFromOptions(currentItem);
		};

		self.nextQuestion = function () {
			var currentQuestion = self.surveyQuestions()[self.activeQuestion()];
			var currentAnswer = self.activeAnswer();
			var complete = false;

			if (self.activeQuestion() === (self.surveyQuestions().length - 1)) {
				complete = true;
				self.isLoading(true);
			}

			var answerId = null;
			if (currentAnswer) {
				answerId = currentAnswer.answerId;
			}

			if (currentQuestion.questionId > -1) {
				surveyService.answerQuestion(currentQuestion.questionId, currentQuestion.answerText, answerId, complete)
					.then(function (result) {
						var navigateToNextQuestion = true;
						currentQuestion.questionAnswered = true;
						if (complete && result) {
							env.userInfo.hasSurvey(false);
							self.isCompleted(true);
							frontend.notification.success({ text: Strings.SurveySentSuccessfully });
							self.closeModal();
						} else if (complete && !result) {
							var firstUnanswered = _.findIndex(self.surveyQuestions(), function (sq) {
								return sq.questionAnswered === false && sq.questionType > -1;
							});

							if (firstUnanswered > -1) {
								var currentIndex = self.activeQuestion();
								var newIndex = firstUnanswered;
								self.activeQuestion(newIndex);
								var item = self.surveyQuestions()[newIndex];
								navigateToNextQuestion = false;
								self.goTo(newIndex, currentIndex, item);
							}
						}

						if (navigateToNextQuestion) {
							self.goToNextQuestion();
						}
					})
					.always(function () {
						self.isLoading(false);
					});
			} else {
				self.goToNextQuestion();
			}
		};

		self.setActiveAnswerFromOptions = function (item) {
			self.activeAnswer((_.filter(item.options, { selected: true }) || [])[0]);
		};

		self.goToNextQuestion = function () {
			if (self.activeQuestion() < (self.surveyQuestions().length - 1)) {
				self.activeQuestion(self.activeQuestion() + 1);
			}

			self.setActiveAnswerFromOptions(self.surveyQuestions()[self.activeQuestion()]);
		};

		self.closeModal = function () {
			self.modal.close();
		};

		self.getTemplate = function (questionType) {
			var id = _.findKey(enums.surveyQuestionType, function (val) {
				return val === questionType;
			});

			switch (id) {
			case 'smileySelectorOptional':
			case 'smileySelectorRequired':
				return 'survey-radio-smiley';
			case 'freeText':
				return 'survey-open-question';
			case 'wayOfWorking':
				return 'survey-way-of-working';
			case 'multipleChoices':
				return 'survey-radio';
			default:
				return 'survey-intro';
			}
		};

		self.getIndex = function (item) {
			if (item) {
				var questions = self.surveyQuestions()[self.activeQuestion()];
				var position = _.findIndex(questions.options, item);
				return (position > 0) ? position : 0;
			}

			return false;
		};

		self.loader = surveyService.getActiveSurvey()
			.done(function (survey) {
				if (survey && survey.questions) {
					self.surveyQuestions([{
						intro: true,
						questionText: survey.surveyText,
						questionType: -1,
						questionAnswered: _.filter(survey.questions, { questionAnswered: true }).length > 0
					}].concat(survey.questions));

					var lastActiveQuestion = _.findIndex(self.surveyQuestions(), { questionAnswered: false });
					self.activeQuestion(lastActiveQuestion !== -1 ? lastActiveQuestion : 0);
				}
			});

		self.getButtonText = function () {
			var questionIndex = self.activeQuestion();
			var surveyLength = self.surveyQuestions().length;

			if (questionIndex === 0) {
				return Strings.SurveyStart;
			} else if (questionIndex < (surveyLength - 1)) {
				return Strings.SurveyNext;
			} else {
				return Strings.SurveyFinish;
			}
		};
	}

	// This method is exposed to components and the MasterLayout
	SurveyViewModel.prototype.openSurvey = function (force) {
		if ((!$.cookie('surveyIgnored') || force === true) && env.userInfo.hasSurvey()) {
			var isClosable = surveyService.isSurveyClosable(new Date());

			frontend.modal.show({
				require: 'v3/Common/Components/Survey/Survey.Component',
				modalClass: 'modal survey',
				backgroundClass: 'survey',
				clickClose: false,
				showClose: isClosable,
				closable: false,
				params: {
					isClosable: isClosable
				}
			}).always(function () {
				$.cookie('surveyIgnored', true, {
					expires: surveyService.getEndOfBusinessDayTime(),
					path: '/'
				});
			});
		}
	};

	return { viewModel: SurveyViewModel, template: htmlString };
});
